import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "49",
  height: "44"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.583.667c.734 0 1.334.597 1.334 1.333v4h16V2c0-.736.6-1.333 1.333-1.333s1.333.597 1.333 1.333v4h2.667a5.336 5.336 0 0 1 5.333 5.333v5.392a14 14 0 0 0-1.333-.058c-.45 0-.892.016-1.333.058v-.058h-32V38a2.665 2.665 0 0 0 2.666 2.667h19.35a15 15 0 0 0 2.884 2.666H5.583A5.336 5.336 0 0 1 .25 38V11.333A5.333 5.333 0 0 1 5.583 6H8.25V2c0-.736.6-1.333 1.333-1.333m22.667 8H5.583a2.665 2.665 0 0 0-2.666 2.666V14h32v-2.667a2.664 2.664 0 0 0-2.667-2.666m3.925 16c.808 0 1.333.6 1.333 1.333v4h2.742c.733 0 1.333.6 1.333 1.333 0 .734-.6 1.334-1.333 1.334h-4.075c-.658 0-1.333-.6-1.333-1.334V26c0-.733.675-1.333 1.333-1.333M24.25 31.333c0-6.625 5.375-12 12-12s12 5.375 12 12-5.375 12-12 12-12-5.375-12-12m12 9.334a9.33 9.33 0 0 0 9.333-9.334A9.33 9.33 0 0 0 36.25 22a9.33 9.33 0 0 0-9.333 9.333 9.33 9.33 0 0 0 9.333 9.334"
    }, null, -1)
  ])))
}
export default { render: render }